const about_tr ={
    title:"Ankor Makina",
    desc_p: "Gemi Bakım Onarım ve Metal İmalat Çözümleri",

    p_1:"gemi bakım-onarım, metal imalat ve tersane hizmetleri alanlarında uzun yıllara dayanan tecrübesiyle faaliyet göstermektedir. Denizcilik sektörüne yönelik olarak gemi makine ekipmanları, güverte teçhizatları, gemi donatım çalışmaları, mekanik bakım ve onarım hizmetleri ile boru ve hidrolik sistemler alanlarında güvenilir çözümler sunmaktadır. Modern üretim altyapımız kapsamında fiber lazer kesim, torna ve talaşlı imalat çalışmalarıyla projelere hızlı ve yüksek hassasiyetli üretim desteği sağlanmaktadır.",
    p_2:"Atölye imalat kabiliyeti ile sahada hızlı müdahale gücünü birleştiren Ankor Makina, denizcilik standartlarına uygun üretim anlayışıyla çalışır. Bakım, onarım ve imalat süreçlerinde kalite, dayanıklılık ve güvenlik öncelikli yaklaşım benimsenir.",
    p_3:"Modern üretim altyapımız, lazer kesim teknolojimiz ve tecrübeli teknik ekibimiz sayesinde; projeye özel metal imalat çözümleri geliştirilir. Tersaneler, gemi işletmecileri ve endüstriyel tesisler için ölçülü, uygulanabilir ve sürdürülebilir çözümler üretmek temel hedefimizdir.",
   
    p_1_title: "Denizcilik Hizmetlerinde Kapsamlı Tecrübe",
    p_2_title: "Entegre Atölye ve Saha Çözümleri",
    p_3_title: "Projeye Özel Mühendislik ve Sürdürülebilir Üretim",

    title_1: "Lorem Ipsum 1",
    text_1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. 1",
    title_2: "Lorem Ipsum 2",
    text_2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. 2",
    title_3: "Lorem Ipsum 3",
    text_3: "Lorem ipsum dolor sit amet consectetur adipisicing elit. 3",
    title_4: "Lorem Ipsum 4",
    text_4: "Lorem ipsum dolor sit amet consectetur adipisicing elit. 4"
}

const about_en ={
    title:"Ankor Machine",
    desc_p: "Ship Maintenance, Repair and Metal Fabrication Solutions",

    p_1: "Operates with many years of experience in the fields of ship maintenance and repair, metal fabrication, and shipyard services. It provides reliable solutions to the maritime industry in areas such as ship machinery equipment, deck equipment, outfitting works, mechanical maintenance and repair services, as well as piping and hydraulic systems. Within the scope of our modern production infrastructure, we offer fast and high-precision manufacturing support for projects through fiber laser cutting, turning, and machining processes.",
    p_2: "Combining its workshop manufacturing capability with rapid on-site intervention, Ankor Makina works in accordance with maritime standards. In maintenance, repair, and production processes, a quality-, durability-, and safety-oriented approach is adopted as a priority.",
    p_3: "Thanks to our modern production infrastructure, laser cutting technology, and experienced technical team, project-specific metal fabrication solutions are developed. Our main goal is to deliver precise, practical, and sustainable solutions for shipyards, ship operators, and industrial facilities.",


    p_1_title: "Extensive Experience in Maritime Services",
    p_2_title: "Integrated Workshop and On-Site Solutions",
    p_3_title: "Project-Specific Engineering & Sustainable Production",


    title_1: "ENG Lorem Ipsum 1",
    text_1: "ENG Lorem ipsum dolor sit amet consectetur adipisicing elit. 1",
    title_2: "ENG Lorem Ipsum 2",
    text_2: "ENG Lorem ipsum dolor sit amet consectetur adipisicing elit. 2",
    title_3: "ENG Lorem Ipsum 3",
    text_3: "ENG Lorem ipsum dolor sit amet consectetur adipisicing elit. 3",
    title_4: "ENG Lorem Ipsum 4",
    text_4: "ENG Lorem ipsum dolor sit amet consectetur adipisicing elit. 4"
   
}

module.exports = { about_tr, about_en}